import { LocaleCode } from "./lang";

export type Translations = {
    [locale in LocaleCode]?: string;
};

export enum TranslationsStatus {
    Needed = "needed",
    Done = "done",
    Pending = "pending",
    Error = "error"
}

export interface SaleTranslationsStatus {
    status: TranslationsStatus;
    done: number;
    needed: number;
    missingTranslations: {
        sale: {
            // counters of missing translations
            description_translations: number;
            exhibitions_address_access_translations: number;
            name_translations: number;
            payment_conditions_translations: number;
            pictures_credits_translations: number;
            sales_conditions_translations: number;
        };
        items: {
            // list of items and their missing translations
            [itemId: number]: { description_translations: number };
        };
    };
}

export interface ExhibitionTranslations {
    description_translations?: Translations;
}

export interface SaleTranslations {
    conditions: {
        payment_translations?: Translations;
        sales_translations?: Translations;
    };
    description_translations?: Translations;
    name_translations?: Translations;
    pictures_credits_translations?: Translations;
}


export interface ItemTranslations {
    description_translations?: Translations;
}

export type ItemTranslationsPatch = ItemTranslations;
